function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconLabel = void 0;
var _react = _interopRequireWildcard(require("react"));
var _props = require("../../props");
var _styles = require("../../../../styles");
var _reactNative = require("react-native-web");
var _styles2 = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var IconLabel = exports.IconLabel = (0, _react.memo)(function (_ref) {
  var icon = _ref.icon,
    size = _ref.size,
    type = _ref.type,
    iconColor = _ref.iconColor,
    iconContainerStyle = _ref.iconContainerStyle,
    iconStyle = _ref.iconStyle;
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors;
  var _useStyles = (0, _styles2.useStyles)(),
    styles = _useStyles.styles;
  var _hasIcon = !!icon && type && [_props.ButtonType.icon, _props.ButtonType.iconOutlined, _props.ButtonType.blank].includes(type);
  if (!_hasIcon || !size) return null;
  var Icon = icon;
  return (0, _jsxRuntime.jsx)(_reactNative.View, {
    style: [styles == null ? void 0 : styles["container_".concat(size)], iconContainerStyle],
    testID: "IconLabel",
    children: (0, _jsxRuntime.jsx)(Icon, {
      color: iconColor || colors.brand,
      style: [styles == null ? void 0 : styles["icon_".concat(size)], iconStyle]
    })
  });
});